exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "notification-bar {\n  margin-right: 8px;\n  box-sizing: unset !important;\n}\n\n.mdl-button.mdl-flat {\n  color: #666;\n  background-color: #fff;\n}\n\n.sample-tracking-button {\n  height: 50px;\n  max-width: 78px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 4px 8px 0 8px;\n  white-space: normal;\n  align-items: center;\n}\n\n.sample-tracking-label {\n  font-size: 10px;\n  line-height: 10px;\n}\n\n", ""]);

// exports
